import styled from 'styled-components'

export const Wrapper = styled.div`
  box-sizing: border-box;
  padding: 24px;
  min-height: 140px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-bottom: 1px solid #b7b8c1;
`
export const WineProducer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 7px;
`

export const WineProducerText = styled.div`
  color: #121432;
  font: var(--typography-12-16-regular);
  margin-left: 8px;
`

export const WineName = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  color: #121432;
  margin-bottom: 3px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const WineSpecification = styled.div`
  font-weight: 500;
  font-size: 10px;
  line-height: 140%;
  color: #121432;
`
export const ScoreWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  align-items: center;
`
export const WineInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  box-sizing: border-box;
`

export const ProducerLogo = styled.img`
  display: flex;
  width: 104px;
  height: 104px;
`

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 104px;
  padding: 0;
  margin-right: 16px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
`

export const ScoreLabel = styled.div`
  height: 12px;
  font: var(--typography-10-12-normal);
  font-weight: 600;
  color: #a0a1ad;
  margin: 0 8px;
`
